export const GOALS_GET_BY_COACHEE = 'GOALS_GET_BY_COACHEE';
export const GOALS_GET_BY_ID = 'GOALS_GET_BY_ID';
export const GOALS_POST = 'GOALS_POST';
export const GOALS_DELETE = 'GOALS_DELETE';
export const GOALS_POST_BY_ID = 'GOALS_POST_BY_ID';
export const GOALS_LOADING = 'GOALS_LOADING';
export const GOALS_ERROR = 'GOALS_ERROR';
export const UPDATE_MILESTONE = 'UPDATE_MILESTONE';
